// extracted by mini-css-extract-plugin
export default {"delete-link-type":"delete-link-type--UY3H5Ojz","radio-group":"radio-group--OYUGltiz","delete-tip":"delete-tip--babB9qfw","theme2Reset":"theme2Reset--YYaGFFkJ"};